/** The API and the web app must agree on these literal names — apps/web can't import apps/api's config. */
export const SESSION_COOKIE_NAME = 'chukua.session';
export const CSRF_COOKIE_NAME = 'chukua.csrf';
/** Carries the login step-up challenge id between /auth/login and /auth/two-factor/verify — set only while 2FA is pending, never alongside a session. */
export const TWO_FACTOR_CHALLENGE_COOKIE_NAME = 'chukua.two-factor-challenge';
